import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BackendConfiguration} from '@application/configuration/backend-configuration';
import {TexfabCarpetLastModified} from '@domain/texfab/texfab-carpet-last-modified';
import {TexfabSalesLastModified} from '@domain/texfab/texfab-sales-last-modified';
import {TexfabTuftingLastModified} from '@domain/texfab/texfab-tufting-last-modified';
import {TexfabWeavingLastModified} from '@domain/texfab/texfab-weaving-last-modified';
import {Observable} from 'rxjs';
import {map as rxjsMap} from 'rxjs/operators';
import {Texfab} from './texfab';

@Injectable()
export class HttpTexfabService implements Texfab {
  private httpClient: HttpClient;
  private backendConfiguration: BackendConfiguration;

  public constructor(httpClient: HttpClient, backendConfiguration: BackendConfiguration) {
    this.httpClient = httpClient;
    this.backendConfiguration = backendConfiguration;
  }

  public getCarpetLastModified(): Observable<TexfabCarpetLastModified> {
    return this.httpClient.get(`${this.backendConfiguration.getAggregatorEndpoint()}texfab/planning/last-modified`).pipe(
      rxjsMap((lastModifiedJSON: any) => {
        return TexfabCarpetLastModified.fromJSON(lastModifiedJSON);
      })
    );
  }

  public getWeavingLastModified(): Observable<TexfabWeavingLastModified> {
    return this.httpClient.get(`${this.backendConfiguration.getProductionOrderEndpoint()}production-orders/lite/last-modified`).pipe(
      rxjsMap((lastModifiedJSON: any) => {
        return TexfabWeavingLastModified.fromJSON(lastModifiedJSON);
      })
    );
  }

  public getTuftingLastModified(): Observable<TexfabTuftingLastModified> {
    return this.httpClient.get(`${this.backendConfiguration.getProductionOrderEndpoint()}production-orders/tuft/last-modified`).pipe(
      rxjsMap((lastModifiedJSON: any) => {
        return TexfabTuftingLastModified.fromJSON(lastModifiedJSON);
      })
    );
  }

  public getSalesLastModified(): Observable<TexfabSalesLastModified> {
    return this.httpClient.get(`${this.backendConfiguration.getEndpoint()}texfab/sales/last-modified`).pipe(
      rxjsMap((lastModifiedJSON: any) => {
        return TexfabSalesLastModified.fromJSON(lastModifiedJSON);
      })
    );
  }
}
